import { c } from "./createLucideIcon-BuuoCVvz.js";
/**
 * @license lucide-react v0.503.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], t = c("check", e);
export {
  t as C
};
//# sourceMappingURL=check-B9pOV8LL.js.map
